import { useContext, createContext, useState } from "react";
import {axiosInstance} from "../helpers/axiosInstance";
/**
 * Crear contexto de los resultados de búsqueda ( finder )
 * @type {React.Context<undefined>}
 */
const SearchContext = createContext(undefined);

/**
 * COMPONENTE PRINCIPAL
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export default function SearchProvider({ children }){
    /**
     * Guardar los datos de la búsqueda
     */
    const [results, setResults] = useState(null);
    /**
     * Guardar los datos de paginacíon
     */
    const [pagination, setPagination] = useState(null);
    /**
     * Mostrar mensaje al usuario sí no se encuentran resultados o si el servidor no responde
     */
    const [message, setMessage] = useState("");
    /**
     * Activar icono de carga mientras responde el servidor
     */
    const [loader, setLoader] = useState(false );
    /**
     * Guarda el id del tab activo (id de contrato)
     */
    const [activekey, setActiveKey] = useState('home');

    /**
     * @function fetchData Peticíon al servidor ( búsqueda de contrato)
     * @param value
     */
    function fetchData(value){

        setActiveKey('home');
        setLoader(true);
        localStorage.removeItem('contrato');
        localStorage.removeItem('pagination');
        localStorage.removeItem('searchRequest');
        localStorage.removeItem('currentPage');

         /**
         * @param res.data.contratos guarda 15 contratos por peticion al servidor
         * @param res.data.paginacion cuenta de los contratos mostratos y el total
         * */
            axiosInstance.get( "finder?query=" + value)
            .then((res) => {

                setLoader(false);

                    if (Array.isArray(res.data)  && res.data.length > 0){
                        /**
                         * Guardar datos de búsqueda y paginación
                         */
                        setResults(res.data);

                        const pag = {
                            rpp : res.headers['x-fd-rpp'],
                            registros : res.headers['x-fd-registros'],
                            pagina : res.headers["x-fd-pagina"]
                        };
                        setPagination(pag);
                        /**
                         * Se guarda la información en el localStorage por si se reinica la página
                         */
                        localStorage.setItem("contrato", JSON.stringify(res.data));
                        localStorage.setItem("searchRequest", JSON.stringify(value));
                        localStorage.setItem("pagination", JSON.stringify(pag));
                        localStorage.setItem("currentPage", JSON.stringify(1));
                    } else {

                        setResults(null);
                        setPagination(null);

                        setMessage(`Sin coincidencias para ${value}`);
                    }

            }).catch((error) => {

                setLoader(false);
                setResults([]);
                setMessage("No se pudo procesar la solicitud, intente más tarde");
                console.error(error)

            });
    }


    /**
     * @const handlePageChange Petición por número de página
     * @param pageNumber
     */

    const handlePageChange =  async (pageNumber) => {
        try {
            const busqueda = JSON.parse(localStorage.getItem('searchRequest'));
            setLoader(true);
            const res = await axiosInstance.get("finder?query=" + busqueda + "&pg=" + pageNumber);
            /**
             * Actualizar datos de búsqueda y paginación
             */
            setResults(res.data);

            const pag = {
                rpp : res.headers['x-fd-rpp'],
                registros : res.headers['x-fd-registros'],
                pagina : res.headers['x-fd-pagina']
            };
            setPagination(pag);
            /**
             * Actualizar la información del localStorage
             */
            localStorage.setItem("contrato", JSON.stringify(res.data));
            localStorage.setItem("pagination", JSON.stringify(pag));
            setLoader(false);
        } catch(error) { console.error(error)}
    }

    /**
     * @function inputSearch Se hace la búsqueda si se ingresaron más de 5 carácteres, sí es asi se llama a fetchData
     * @param value
     */
    function inputSearch(value){
        if(value.length >= 5){
            fetchData(value);
        }
    }

    /**
     * @const getInfoStorage Obtener los datos del localStorage
     * @param clave
     * @returns {any}
     */
    const getInfoStorage = (clave) => {
        return JSON.parse(localStorage.getItem(clave));
    }

    /**
     * @const cleanData limpiar los estados del contexto
     */

    const cleanData = () => {
        setResults([]);
        setPagination({});
        setMessage("");
    }

  return (
    <SearchContext.Provider value={{
        results,
        pagination,
        message,
        loader,
        inputSearch,
        handlePageChange,
        getInfoStorage,
        cleanData,
        activekey,
        setActiveKey
    }}>
      {children}
    </SearchContext.Provider>
  );

};

export const useSearch = () => {
  return useContext(SearchContext);
};
